import React__default from "react";
import { ClickAreaContext } from "./click-area-context.mjs";
const ClickArea = ({ children }) => {
  const [trigger, setTrigger] = React__default.useState(null);
  return /* @__PURE__ */ React__default.createElement(ClickAreaContext.Provider, { value: React__default.useMemo(() => ({ trigger, setTrigger }), [trigger]) }, React__default.isValidElement(children) ? React__default.cloneElement(children, {
    // Cannot be click area if child is not clickable, otherwise it adds a hover effect to a non-interactive element.
    // Area is considered clickable only if it includes a trigger.
    className: [trigger ? "click-area" : void 0, children.props.className].filter(Boolean).join(" "),
    onClick: trigger ? (event) => {
      var _a, _b;
      const selection = window.getSelection();
      const textSelected = selection ? selection.toString() : void 0;
      if (!textSelected) {
        trigger.click();
      }
      (_b = (_a = children.props).onClick) == null ? void 0 : _b.call(_a, event);
    } : children.props.onClick
  }) : (
    /* istanbul ignore next */
    null
  ));
};
export {
  ClickArea
};
